(function () {
  angular.module("akitabox.desktop.admin.job.accountList", [
    "akitabox.constants",
    "akitabox.core.services.job",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.job.create",
  ]);
})();
